// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","260":"ae51ba48","691":"component---src-pages-index-tsx","994":"b98bc7c3"}[chunkId] + "-" + {"218":"93993d90675a315e8eac","260":"f3adcae9b5fa86a19029","691":"eb5008bc4b23078c8095","994":"325e2dafcc943d72c67e"}[chunkId] + ".js";
};